import { render, staticRenderFns } from "./AdminFrequentQuestionList.vue?vue&type=template&id=21942a25&"
import script from "./AdminFrequentQuestionList.vue?vue&type=script&lang=js&"
export * from "./AdminFrequentQuestionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports